module.exports = __webpack_public_path__ + "static/DWI20_Reg_1700x1200_Franken-85dc3929f6df1512c701157d4af03b18.jpeg";